import React, { useEffect } from 'react';
import {
  Box,
  Heading,
  Text,
  VStack,
  Container,
  Divider,
  Avatar,
  HStack,
  Link as ChakraLink,
  useColorModeValue,
  background,
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import RampageStart from '../assets/Buttman_flyer_idea.png';
import Timer from './tournamentTimer';

interface CollectionCardProps {
  title: string;
  description: string;
  image?: string;
  alt?: string;
  link?: string;
}

const CollectionCard: React.FC<CollectionCardProps> = ({
  title,
  description,
  image,
 
  link,
}) => {
  const bg = useColorModeValue('blackAlpha.600', 'whiteAlpha.100');
  const border = useColorModeValue('gray.200', 'whiteAlpha.300');


  return (
    <Box
      bg={bg}
      border="1px solid"
      borderColor={border}
      borderRadius="2xl"
      p={6}
      boxShadow="xl"
      backdropFilter="blur(12px)"
      transition="all 0.3s ease"
      _hover={{
        transform: 'translateY(-6px)',
        boxShadow: 'dark-lg',
        borderColor: 'orange.900',
      }}
    >
      <HStack spacing={4} mb={4} align="center">
        {image && (
          <Avatar
            src={image}
            name={title}
            size="lg"
            border="2px solid white"
            bg="gray.700"
            boxShadow="lg"
          />
        )}

        <Heading
           color="yellow"
           textShadow={'5px 0px 5px red'}
          size="lg"
      
          noOfLines={2}
          fontWeight="bold"
        >
          {link ? (
            <ChakraLink
              as={RouterLink}
              to={link}
              _hover={{ textDecoration: 'underline' }}
            >
              {title}
            </ChakraLink>
          ) : (
            title
          )}
        </Heading>
      </HStack>

      <Text color="gray.300" fontSize="md" lineHeight="tall">
        {description}
      </Text>
    </Box>
  );
};

const Home: React.FC = () => {
  
  useEffect(() => {
    setTimeout(() => {
      const PlayDiv2 = document.getElementById('RampageStart');
      if (PlayDiv2) {
        PlayDiv2.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 500);
  }, []);

  const collections = [
    {
      title: 'Reckless Robots (Gen 1)',
      description:
' Reckless Robots is a collection of 2,100 unique, hand-drawn NFTs launched on the Cronos blockchain in February 2022. Known for its detailed artwork, the collection sold out in under six hours. It features accelerated NFT staking and a unique burning mechanism where the weakest bids are bought from secondary markets and eliminated, reducing the total supply to increase rarity and staking rewards. Minted at 300 CRO (200 CRO for whitelist and founding members), the project emphasizes community engagement and innovative NFT utility.',
      image: 'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fmiro.medium.com%2Fv2%2Fresize%3Afit%3A2400%2F1*LdV69tW26OgwhgQNZpnv3Q.png&f=1&nofb=1&ipt=6712c22bf1f409b3732eb299a34d77280fd32533996d9034face0de356c7c3fb',
      link: 'https://crypto.com/price/nft-collections/RECK-1?blockchain=1',
    },
    {
      title: 'Cronos Chibis',
      description:
        'Cronos Chibis is a collection of 2,222 unique, hand-drawn NFTs on the Cronos blockchain, launched via Lootpad.io. Inspired by Japanese art, it offers staking, passive income, and exclusive rewards like $CRO airdrops.',
      image: 'https://miro.medium.com/v2/resize:fit:720/format:webp/1*TUvGu-bIv5Nqrb0QwO5LiQ.jpeg',
      link: 'https://app.ebisusbay.com/collection/cronos/cronos-chibis',
    },
   
    {
      title: 'Reckless Robots Legends (Gen 2)',
      description:
        `Gen 2 features 3,000 NFTs with classes like The Commander and The Beast. Collection will serve as an entry token to the Reckless Rampage game. The collection is currently minting ${<Text as ={RouterLink}> here </Text>} ` ,
      image: 'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fpbs.twimg.com%2Fmedia%2FFpGGnvKaUAY0Kdd.jpg&f=1&nofb=1&ipt=dd9324d236eaa6f9366790290d683d23dc5555b28dc567a130b98295e57f834b',
      link: 'https://app.ebisusbay.com/collection/cronos/0xf96ec7c11d311920833753fab9b174b6fd53517e',
    },
    {
      title: '$BUTT - Brandon B. Buttman',
      description:
        "The meme hero of Croham City. $BUTT is more than a coin — it's community governance in action. Get yours now and join the revolution. And remember, NO F*** BUTTS!",
      
        image: RampageStart,
      link: '/wallet',
    },
  ];

  return (
    <Container id="RampageStart" bg={'blackAlpha.600'} maxW="container.lg" py={{ base: 8, md: 12 }}>
      <VStack spacing={10} align="stretch">
        <Box textAlign="center"      bg={'blackAlpha.600'}
      border="1px solid"
      borderColor={'white'}
      borderRadius="2xl"
      p={6}
      boxShadow="xl"
      backdropFilter="blur(12px)"
      transition="all 0.3s ease">
          <Text className='header'
   fontSize={{ base: '3vmin', md: '4vmin' }}
         
            color="white"
         
            textDecoration="underline"
            
          >
            PROJECT CROHAM
          </Text>
          <Text
            fontSize={{ base: 'lg', md: 'xl' }}
            color="white"
            lineHeight="tall"
          >
            Croham City—where shadows loom, and hesitation meets its match.
            As ButtMan blazes the trail, more bold projects rise.
            This is just the beginning. 

            Croham city merges multiple Cronos projects by Reckless Overseer under one roof.
           <br></br>  Read more about the merge <span><Text color={'white'} textDecoration={'underline'} as={RouterLink} to={'https://medium.com/@recklessrobots/the-merge-b79553157e46'} >here </Text></span>
           </Text>
        </Box>

        <Divider />

        <Text className='header'
   fontSize={{ base: '3vmin', md: '4vmin' }}
   color="yellow"
   textShadow={'5px 0px 5px red'}>
          The Croham Projects (in order of appearance..)
       </Text>

        {collections.map((collection, index) => (
          <React.Fragment key={collection.title}>
            <CollectionCard
              title={collection.title}
              description={collection.description}
              image={collection.image}
              alt={collection.title}
              link={collection.link}
            />
            {index < collections.length - 1 && <Divider />}
          </React.Fragment>
        ))}

        <Box  textAlign="center" mt={8}>
          <ChakraLink
            href="https://vvs.finance/swap?inputCurrency=CRO&outputCurrency=0x2dfA528939D38a3654ad44a4748BE591e283a32f"
            isExternal
            fontSize={{ base: 'lg', md: '2xl' }}
            color="yellow"
            textShadow={'5px 0px 5px red'}
            _hover={{ textDecoration: 'underline' }}
          >
            GET YOUR HANDS ON THAT $BUTT at Cronos DEXs'
          </ChakraLink>
          <Timer />
        </Box>
      </VStack>
    </Container>
  );
};

export default Home;
